import {createAction, handleActions} from 'redux-actions';
import {Api} from "../../api/api";
import {
    fetchSubmitForm,
    fetchSubmitFormFailed,
    fetchSubmitFormSuccess,
} from '../common/submitForm';
import { logout, onForbidden } from '../account/login';

import _ from 'lodash';
import {hideModal} from "../common/activeModal";

//- Actions
export const fetchGetAccreditationGroupsFailed = createAction('FETCH_GET_ACCREDITATION_GROUPS_FAILED');
export const fetchGetAccreditationGroupsSuccess = createAction('FETCH_GET_ACCREDITATION_GROUPS_SUCCESS');
export const onGetAccreditationGroupsSuccess = (data) => (dispatch) => {
    let isEmpty = data.empty;
    let currentPage = data.number;
    if ((!isEmpty && currentPage !== 0) || currentPage === 0){
        dispatch(fetchGetAccreditationGroupsSuccess(data));
    } else {
        dispatch(fetchGetAccreditationGroups(currentPage - 1));
    }
};
export const fetchGetAccreditationGroups = createAction(
    'FETCH_GET_ACCREDITATION_GROUPS',
    (page) => Api.getAccreditationGroups(page),
    () => ({
        apiCall: true,
        onSuccess: onGetAccreditationGroupsSuccess,
        onFail: fetchGetAccreditationGroupsFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onGetAccreditationGroupsForCurrentPage = () => (dispatch, getState) => {
    let currentPage = getCurrentPageForAccreditationGroups(getState());
    dispatch(fetchGetAccreditationGroups(currentPage));
};

export const fetchRegisterAccreditationGroup = (data) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRegisterAccreditationGroup(data));
};
export const onRegisterAccreditationGroup = createAction(
    'FETCH_REGISTER_ACCREDITATION_GROUP',
    (data) => Api.registerAccreditationGroup(data),
    () => ({
        apiCall: true,
        onSuccess: onChangeAccreditationGroupSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

export const onChangeAccreditationGroupSuccess = () => (dispatch) => {
    dispatch(fetchSubmitFormSuccess());
    dispatch(onGetAccreditationGroupsForCurrentPage());
    dispatch(hideModal());
};


export const fetchRemoveAccreditationGroup = (groupId) => dispatch => {
    dispatch(fetchSubmitForm());
    dispatch(onRemoveAccreditationGroup(groupId));
    dispatch(hideModal());
};

export const onRemoveAccreditationGroupSuccess = () => dispatch => {
    dispatch(fetchSubmitFormSuccess())
    dispatch(onGetAccreditationGroupsForCurrentPage());
};

export const onRemoveAccreditationGroup = createAction(
    'FETCH_REMOVE_ACCREDITATION_GROUP',
    (groupId) => Api.removeAccreditationGroup(groupId),
    () => ({
        apiCall: true,
        onSuccess: onRemoveAccreditationGroupSuccess,
        onFail: fetchSubmitFormFailed,
        onUnauthorized: logout,
        onForbidden: onForbidden
    })
);

//- State
const initialState = {
    fetching: false,
    data: null,
    error: null,
    currentPage: null,
    totalPages: null
};

//- Reducers
export default handleActions({
    FETCH_GET_ACCREDITATION_GROUPS: (state) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: null, fetching: true };
    },
    FETCH_GET_ACCREDITATION_GROUPS_FAILED: (state, action) => {
        return { ...state, data: null, currentPage: null, totalPages: null, error: action.payload, fetching: false };
    },
    FETCH_GET_ACCREDITATION_GROUPS_SUCCESS: (state, action) => {
        return { ...state, data: action.payload.content, currentPage: action.payload.number, totalPages: action.payload.totalPages, error: null, fetching: false };
    }
}, initialState);

//- Selectors
export const getAccreditationGroups = state => state.accreditationGroups;

export const loadingAccreditationGroups = state => getAccreditationGroups(state).fetching;

export const getCurrentPageForAccreditationGroups = state => getAccreditationGroups(state).currentPage;

export const getTotalPagesForAccreditationGroups = state => getAccreditationGroups(state).totalPages;

export const getAccreditationGroupsData = state => {
    if (_.isNil(getAccreditationGroups(state).data)) {
        return null;
    }

    return _.map(getAccreditationGroups(state).data, accreditationGroup => ({
            id: accreditationGroup.id,
            name: accreditationGroup.name,
            inserterCount: accreditationGroup.inserterCount,
            validatorCount: accreditationGroup.validatorCount
        })
    );
};

export const getAccreditationGroupsDataForSelect = state => {
    if (_.isNil(getAccreditationGroups(state).data)) {
        return null;
    }

    return _.map(getAccreditationGroups(state).data, accreditationGroup => ({
            value: accreditationGroup.id,
            label: accreditationGroup.name
        })
    );
};



// WEBPACK FOOTER //
// ./src/reducers/organization/accreditationGroups.js